<template>
  <BaseDialog max-width="800" persistent :value="true">
    <template #modal>
      <BaseCosmoCard>
        <template #title>
          <div class="modal_header">
            <BaseTitle v-text="$t('workflow_delete_folder.modal.title')" />
            <BaseButtonIcon
              class="close_icon"
              icon="$mdiClose"
              :disabled="isSubmiting"
              @click="reset()"
            />
          </div>
        </template>
        <div class="modal_content">
          <v-progress-linear
            v-if="isSubmiting"
            class="progression"
            indeterminate
          />
          <div class="input_group">
            <div
              class="input_label"
              v-text="$t('workflow_delete_folder.modal.label')"
            />
            <BaseTextField
              v-model="deletionDelay"
              outlined
              autofocus
              type="number"
              :placeholder="$t('workflow_delete_folder.modal.placeholder')"
              :disabled="isSubmiting"
              :error-messages="deletionErrorValue"
              :has-error="!!deletionErrorValue"
              @keypress.enter="submit()"
            />
          </div>
        </div>
        <div class="modal_footer">
          <BaseButton
            :disabled="isSubmiting"
            color="grey"
            type="secondary"
            @click="reset()"
          >
            {{ $t("utils.cancel") }}
          </BaseButton>
          <BaseButton
            :disabled="isSubmiting"
            color="primary"
            type="primary"
            @click="submit()"
          >
            {{ $t("utils.validate") }}
          </BaseButton>
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>
<script>
import WorkflowAPI from "@/modules/Admin/Services/workflow.api";

export default {
  name: "WorkflowDeleteFoldersModal",
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSubmiting: false,
      deletionDelay: null,
    };
  },
  computed: {
    deletionErrorValue() {
      const tmp = parseInt(this.deletionDelay, 10);
      if (Number.isNaN(tmp)) return "";
      if (tmp < 0) return "La valeur doit être un entier positif";
      return "";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.deletionDelay = this.workflow.deletionDelay;
    },
    reset() {
      if (this.isSubmiting) return;
      this.deletionDelay = 0;
      this.$emit("close");
    },
    async submit() {
      if (this.deletionErrorValue) return;
      this.isSubmiting = true;
      try {
        const tmp = parseInt(this.deletionDelay, 10);
        const payload = {
          deletion_delay: !Number.isNaN(tmp) ? tmp : null,
        };
        await WorkflowAPI.patchOrganizationWorkflow(
          this.organizationId,
          this.workflow.id,
          payload
        );
        this.$emit("workflowUpdated", {
          ...this.workflow,
          deletionDelay: payload.deletion_delay,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.snackbar.success.workflowModifiedSuccessfully"
          ),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
      this.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 8px;
  flex-wrap: wrap;
  .modal_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #353542;
  }
  .close_icon {
    margin-left: auto;
  }
}
.modal_content {
  padding-top: 24px;
  position: relative;
  .progression {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
  }
  .input_group {
    .input_label {
      color: #353542;
      font-family: Inter;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;

      margin-bottom: 10px;
    }
  }
}
.modal_footer {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  padding: 8px 0;
  gap: 16px;
}
</style>
